import router from '@/router'
import { useUserStore } from '@/stores/user'
import { useErrorStore } from '@/stores/error'
import { getFieldMessage } from '@/utils/message'

export function useErrorHandler() {
  const userStore = useUserStore()
  const errorStore = useErrorStore()

  /**
   * APIエラー共通処理
   */
  const handleApiError = async (error: any) => {
    if (router.currentRoute.value.name === 'ErrorPage') return

    let title = getFieldMessage('systemerror913_1')
    let message = getFieldMessage('systemerror913_2')

    if (error.response) {
      const status = error.response.status

      if (status === 400) {
        title = getFieldMessage('invalidparameter903_1')
        message = getFieldMessage('invalidparameter903_2')
      } else if (status === 401) {
        title = getFieldMessage('sessionexpired902_1')
        message = getFieldMessage('sessionexpired902_2')
      } else if (status === 500) {
        title = getFieldMessage('connectionfails901_1')
        message = getFieldMessage('connectionfails901_2')
      }
    }

    userStore.clearUserInfo()
    errorStore.setError(title, message)

    // 現在 ErrorPage でなければ遷移
    if (router.currentRoute.value.name !== 'ErrorPage') {
      try {
        await router.push({ name: 'ErrorPage' })
      } catch {
        // NavigationDuplicatedなどを無視
      }
    }
  }

  return { handleApiError }
}
